import React, { useEffect, useState } from "react";
import "./Trading.css";
import DatePicker, { CalendarContainer } from "react-datepicker";
import InfoPopup from "../CommonComponents/InfoPopup/InfoPopup";
import CustomSwitch from "../CommonComponents/CustomSwitch/CustomSwitch.jsx";
import BubbleSvgButton from "../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import TradingGraph from "./TradingGraph";
import TradingCards from "./TradingCards";
import TradeTable from "./TradeTable";
import { useSelector, useDispatch } from "react-redux";
import useApi from "../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../helpers/toast/toastify.js";
import { setRefetchSpecificUser } from "../../../redux/multicommunity/multicommunity";
import DashboardMarketSelectBar from "../CommonComponents/DashboardMarketSelect/DashboardMarketSelectBar";

const DateSelector = ({ selectedDate, setSelectedDate }) => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const Container = ({ children, className }) => {
    return (
      <div className="calendarContainer">
        <CalendarContainer className={`w-100 ${className}`}>
          <div style={{ width: "100%", position: "relative" }}>{children}</div>
        </CalendarContainer>
      </div>
    );
  };

  return (
    <div className="mamberDateSelectBox">
      <DatePicker
        calendarContainer={Container}
        className="form-control memberDropDown"
        icon={
          <svg
            height="5.083"
            viewBox="555.521 760 9.149 5.083"
            width="9.149"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M560.095 765.083 555.521 760h9.149l-4.575 5.083Z"
              data-name="Triangle"
              fill-rule="evenodd"
            />
          </svg>
        }
        onChange={(date) => setSelectedDate(date)}
        placeholderText="Select end date"
        selected={selectedDate}
        showIcon
      />
    </div>
  );
};

const CmNoLinkTrading = () => {
  const { user } = useSelector((state) => state.user);
  const community = useSelector((state) => state?.user?.user?.leaderCommunity);

  const dispatch = useDispatch();
  const [endDate, setEndDate] = useState(null);
  const [originalDate, setOriginalDate] = useState(null);
  const [isdetail, setIsdetail] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [optimisticEmailReport, setOptimisticEmailReport] = useState(null);
  const [monthlyReportUpdated, setMonthlyReportUpdated] = useState(false);
  const api = useApi();

  const [stats, setStats] = useState({});

  const getUserStats = async () => {
    const response = await api("post", "multiCommunity/getSpecificUserStats", {
      userIds: [user?._id],
    });
    if (response?.status) setStats(response?.data);
  };

  useEffect(() => {
    if (user) getUserStats();
  }, [user]);

  useEffect(() => {
    if (community) {
      const communityDate = new Date(community?.statsFrom);
      setEndDate(communityDate);
      setOriginalDate(communityDate);
    }
  }, [community]);

  // Reset optimistic state when user data changes (after successful API call)
  useEffect(() => {
    if (user?.leaderCommunity?.receiveEmailReport !== undefined) {
      setOptimisticEmailReport(null);
    }
  }, [user?.leaderCommunity?.receiveEmailReport]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 576);
    };

    // Check the screen size on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getUtcMidnightISOString = (date) => {
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    return utcDate.toISOString();
  };

  // Helper function to check if date has changed
  const hasDateChanged = () => {
    if (!endDate || !originalDate) return false;
    return endDate.getTime() !== originalDate.getTime();
  };

  const changeStatsDate = async () => {
    const response = await api("post", "community/update", {
      statsFrom: getUtcMidnightISOString(endDate),
      id: community?._id,
    });
    if (response?.status) {
      dispatch(setRefetchSpecificUser(true));
      await getUserStats();
      setOriginalDate(new Date(endDate));
      toastify("Date updated successfully.", "success");
    } else {
      toastify(response?.message || "Unable to change date.");
    }
  };
    const traderMonthlyReport = async () => {
      const currentEmailReportState = user?.getEmailReport;
      const newEmailReportState = !currentEmailReportState;
       
      try {
        const response = await api("post", "users/update-email-report", {
          id: user?._id,
          getEmailReport: newEmailReportState,
        });
        
        if (response?.status) {
          // Update user state in Redux/Context
          dispatch(setRefetchSpecificUser(true));
          setMonthlyReportUpdated(true);
          setTimeout(() => {
            toastify("Email preference set successfully!", "success");
          }, 2000);
        } else {
          toastify(response?.message || "Failed to update email preference");
        }
      } catch (error) {
        toastify("Failed to update email preference");
      }
    };

  const monthlyReport = async () => {
    // Get current state
    const currentEmailReportState = user?.leaderCommunity?.receiveEmailReport;
    const newEmailReportState = !currentEmailReportState;

    // Optimistic UI update - change immediately
    setOptimisticEmailReport(newEmailReportState);

    try {
      const response = await api("post", "community/update", {
        id: user?.leaderCommunity?._id,
        receiveEmailReport: newEmailReportState,
      });

      if (response?.status) {
        dispatch(setRefetchSpecificUser(true));
        setTimeout(() => {
          toastify("Email preference set successfully!", "success");
        }, 2000);
      } else {
        setOptimisticEmailReport(currentEmailReportState);
        toastify(response?.message || "Failed to update email preference");
      }
    } catch (error) {
      setOptimisticEmailReport(currentEmailReportState);
      toastify("Failed to update email preference");
    }
  };

  return (
    <div className="TradingPage CMnolinkTradingPage">
      <DashboardMarketSelectBar />
      <div className="container-fluid g-0">
        <div>
          <div className={`leftContentWrap ${user?.role==="member"?"w-100 mw-100":""}`}>
            <TradingGraph user={user} stats={stats} />
            {/* <TradingCards stats={stats} /> */}
            <TradeTable />
          </div>
          {user.role === "leader" && (
            <>
              <div className="separatorFlexWrap">
                <div className="separatorTrade">
                  <div className="separatorLine"></div>
                </div>
              </div>
              <div className="rightSideBarWrap">
                <div className="accountPerfomance">
                  <p className="title mb-0">
                    <span className="pe-2 d-sm-inline d-none">
                      Calculate your trading account performance from
                    </span>
                    <span className="pe-2 d-sm-none d-inline">
                      Calculate your trading account performance from
                    </span>
                    <InfoPopup
                      contentItems={[
                        { text: "Invite VIP Members", type: "heading" },
                        {
                          text: "Turn this on to create a VIP subscription for your current lifetime(or just a longer access period) members at our cost price of $15/ month. If you define an end date for the VIP member then member will be offered to resubscribe at end of VIP membership. You can turn it off once you’ve onboarded all your VIP members without affecting their subscription.",
                          type: "paragraph",
                        },
                      ]}
                    />
                  </p>
                  <div className="SwithTitle mt-3 d-sm-none d-block">
                    <CustomSwitch
                      checked={isdetail}
                      onChange={() => {
                        setIsdetail(!isdetail);
                      }}
                    />
                    <span className="switchText ps-3">See details</span>
                  </div>
                  {(!isMobile || isdetail) && (
                    <>
                      <DateSelector
                        className="VipMemberDropdown"
                        selectedDate={endDate}
                        setSelectedDate={setEndDate}
                      />
                      {hasDateChanged() && (
                        <div className="mt-2">
                          <BubbleSvgButton
                            text={"Save"}
                            type="button"
                            variant="black"
                            onClick={changeStatsDate}
                            mainDivStyle={{
                              zIndex: "0",
                            }}
                            containerStyling={{
                              justifyContent: "center",
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="reportWrap mt-4">
                  <div className="SwithTitle">
                    <CustomSwitch
                      checked={
                        optimisticEmailReport !== null
                          ? optimisticEmailReport
                          :user?.leaderCommunity?user?.leaderCommunity?.receiveEmailReport:user?.getEmailReport
                      }
                      onChange={()=>{

                      if(user?.leaderCommunity){

                        monthlyReport()
                        return;
                      }
                        traderMonthlyReport()
                      }}
                    />
                    <span className="switchText ps-3">
                      monthly report by email
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CmNoLinkTrading;
